import DateFormatter from "./dateFormatter.js";
/**
 * Attempt to remove /en|/fr from the front of the string if exists
 * @param {String} url
 * @returns {String}
 */
const removeLanguageFromUrl = (url) => {
  const match = url.match(/(?:\/(?:en|fr))([\w\-/\d?_]+)/i);
  return match?.[1] ?? url;
};
 
const extractLanguageFromPathname = (url) => {
  const match = url.match(/^\/(en|fr)(?=\/[\w\-/\d]+)?/i);
  return match?.[1]?.toLowerCase();
};
 
const capitaliseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
 
const sortObjectByValue = (arr) => {
  // index value defines priority level
  if (Array.isArray(arr)) {
    const appCodeList = ["mogo", "md2"];
    return arr.sort(function (a, b) {
      const val1 = a?.app_code?.toLowerCase() ?? "";
      const val2 = b?.app_code?.toLowerCase() ?? "";
      const val_a_activated = a?.is_activated ?? true;
      const val_b_activated = b?.is_activated ?? true;
      if (
        appCodeList.indexOf(val1) === -1 &&
        appCodeList.indexOf(val2) === -1
      ) {
        if (val1 < val2) {
          if (
            (val_a_activated && val_b_activated) ||
            (!val_a_activated && !val_b_activated)
          )
            return -1;
 
          if (!val_a_activated && val_b_activated) return 1;
          if (val_a_activated && !val_b_activated) return -1;
        }
        if (val1 > val2) {
          if (
            (val_a_activated && val_b_activated) ||
            (!val_a_activated && !val_b_activated)
          )
            return 1;
 
          if (!val_a_activated && val_b_activated) return 1;
          if (val_a_activated && !val_b_activated) return -1;
        }
        return 0;
      } else {
        if (appCodeList?.indexOf(val1) < appCodeList?.indexOf(val2)) {
          if (
            (val_a_activated && val_b_activated) ||
            (!val_a_activated && !val_b_activated)
          )
            return 1;
 
          if (!val_a_activated && val_b_activated) return 1;
          if (val_a_activated && !val_b_activated) return -1;
        }
        if (appCodeList?.indexOf(val1) > appCodeList?.indexOf(val2)) {
          if (
            (val_a_activated && val_b_activated) ||
            (!val_a_activated && !val_b_activated)
          )
            return -1;
 
          if (!val_a_activated && val_b_activated) return 1;
          if (val_a_activated && !val_b_activated) return -1;
        }
        return 0;
      }
    });
  } else {
    return arr;
  }
};
 
// hash algo SHA256
function hashSha256(string) {
  const utf8 = new TextEncoder().encode(string);
  return crypto.subtle.digest("SHA-256", utf8).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  });
}
 
function delay(delay) {
  return new Promise((res) => setTimeout(res, delay));
}
 
// strip html caharacters from string
function stripHtmlTags(raw) {
  return raw ? raw.replace(/<[^>]*>/g, "") : "";
}
 
async function handleTokenRequest(tokenhandler) {
  const token = window.sessionStorage.getItem("token") ?? null;
  let tokenExpiry = window.sessionStorage.getItem("tokenExpiry");
  tokenExpiry = tokenExpiry ? new Date(tokenExpiry) : null;
  const isTokenExpired =
    tokenExpiry instanceof Date
      ? new Date() > tokenExpiry 
      : true;
  let newToken = token;
 
  if (isTokenExpired || !newToken || newToken === "null") {
    //clear previous values
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("tokenExpiry");
    newToken = await tokenhandler();
 
    if (!newToken) {
      console.error("Failed to acquire new token");
    } else {
      window.sessionStorage.setItem("token", newToken);
      window.sessionStorage.setItem("tokenExpiry", new Date(Date.now() + 5 * 60 * 1000));  
    }
  } else {
    console.log("Using cached token");
  }
  return newToken;
}
 
// Add JWT decoding function
const decodeJWT = (token) => {
  try {
    // JWT has 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }
    
    // Decode the payload (second part)
    const payload = parts[1];
    
    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    
    // Decode from base64url
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    
    // Parse JSON
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export {
  removeLanguageFromUrl,
  extractLanguageFromPathname,
  capitaliseFirstLetter,
  sortObjectByValue,
  hashSha256,
  delay,
  stripHtmlTags,
  handleTokenRequest,
  decodeJWT,
};
